module.exports = __webpack_public_path__ + "img/water_des_1.423d3813.jpg";